module.exports = __webpack_public_path__ + "static/media/caminho.75c9382f.svg";